// TODO fix the timezone offset so that it is calculated everytime instead as a option initially
const fixedOptions = {
  chart: {
    type: 'solidgauge'
  },
  exporting: {
    enabled: false
  },

  tooltip: {
    enabled: false
  },
  credits: {
    enabled: false
  }
};

export default fixedOptions;
